//import BagModel from './screens/index.vue';
const BagModel = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const bagModelsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.BAG_MODEL_VIEW,
    PERMISSIONS_KEYS.BAG_MODEL_INSERT,
    PERMISSIONS_KEYS.BAG_MODEL_EDIT,
  ])
) {
  bagModelsRoutes.push({
    path: '/bolsas/modelos',
    name: 'Cadastro / Consulta|Bolsa Compart - Cadastro',
    component: BagModel,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { bagModelsRoutes };
